import type { ReactNode } from "react";
import { BrandMark } from "@/components/brand-mark";

/**
 * The frame every screen is drawn in — the markup that used to be `layout()`
 * in the Worker, unchanged in what it produces.
 *
 * The lengths are the old `.top` and `.logo` rules to the value: `1.4rem
 * 1.25rem` of padding and a `.6rem` gap. Rounded to the nearest Tailwind step
 * (`py-6`, `gap-2`) the header came out 3px taller, which moved every screen
 * under it — a shift nothing fails on and a comparison sees immediately.
 *
 * The mark is the one exception to "unchanged": where the console drew a
 * gradient square standing in for a logo it did not have, it now draws the
 * mark the homepage has been using all along. 28px is the homepage's size and
 * not the square's 24 — the drawing is line work rather than a filled shape,
 * and at 24 it reads thin beside the wordmark's weight.
 */
export function Shell({ children }: { children: ReactNode }) {
  return (
    <>
      <div className="mx-auto flex w-full max-w-[1040px] items-center gap-[.6rem] px-[1.25rem] py-[1.4rem]">
        <div className="flex items-center gap-[.6rem] text-xl font-bold tracking-[-.02em]">
          <BrandMark className="size-7" />
          Sitebrew
        </div>
      </div>
      <main className="flex flex-1 items-center justify-center p-6">{children}</main>
    </>
  );
}
